var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExerciseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 5C19.1046 5 20 4.10457 20 3C20 1.89543 19.1046 1 18 1C16.8954 1 16 1.89543 16 3C16 4.10457 16.8954 5 18 5Z",
    stroke: "#FF6B00",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4996 5.5L8.52956 10.2C8.34139 10.4211 8.20363 10.6806 8.12584 10.9603C8.04805 11.2401 8.03211 11.5334 8.07912 11.8199C8.12613 12.1065 8.23496 12.3793 8.39806 12.6195C8.56115 12.8598 8.7746 13.0616 9.02356 13.211L11.2056 14.521C11.4204 14.6505 11.5788 14.8561 11.6491 15.0969C11.7195 15.3377 11.6968 15.5961 11.5856 15.821L8.99956 21",
    stroke: "#FF6B00",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.00262L6.6 4.60262C6.71672 4.42705 6.88595 4.29286 7.08351 4.21922C7.28106 4.14559 7.49684 4.13628 7.7 4.19262L12.5 5.50262L16.5 8.50262L18.6 12.2776C18.7133 12.4814 18.8942 12.6392 19.1115 12.7238C19.3288 12.8083 19.5688 12.8143 19.79 12.7406L22 12.0026",
    stroke: "#FF6B00",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4999 8.5L13.2939 12.235",
    stroke: "#FF6B00",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16L2 21",
    stroke: "#FF6B00",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExerciseIcon);
export default __webpack_public_path__ + "static/media/ExerciseIcon.04053f1c5731db88fabe161c944f8d48.svg";
export { ForwardRef as ReactComponent };